module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00003.e0a073c2.jpg";